// extracted by mini-css-extract-plugin
export default {"multiTitle":"Unstructured_multiTitle__d+W04","title":"Unstructured_title__uJDow","description":"Unstructured_description__7WONH"};